// import React, { useEffect, useState } from "react";
// import UserNavbar from "../../components/common/UserNavbar";
// import UserFooter from "../../components/common/UserFooter";
// import { FaWhatsapp, FaRobot } from "react-icons/fa6";
// import ChatBot from "../../components/common/ChatBot";
// import axios from "axios";

// const formatWhatsAppLink = (inputNumber, defaultCountryCode = "+1") => {
//   if (!inputNumber) return null;

//   // Step 1️⃣: Remove everything except digits and '+'
//   let cleaned = inputNumber.replace(/[^\d+]/g, "");

//   // Step 2️⃣: Handle cases like '001' or '1' prefixes
//   if (cleaned.startsWith("00")) {
//     cleaned = "+" + cleaned.slice(2);
//   }

//   // Step 3️⃣: Ensure it starts with '+'
//   if (!cleaned.startsWith("+")) {
//     // If it starts with country code digit but no '+', add '+'
//     if (cleaned.startsWith("1")) {
//       cleaned = "+" + cleaned;
//     } else {
//       cleaned = defaultCountryCode + cleaned;
//     }
//   }

//   // Step 4️⃣: Remove '+' for WhatsApp link format
//   const waNumber = cleaned.replace("+", "");

//   // Step 5️⃣: Return final WhatsApp link
//   return `https://wa.me/${waNumber}`;
// };

// const UserLayout = (props) => {
//   const [isChatBotOpen, setIsChatBotOpen] = useState(false);
//   const [contactData, setContactData] = useState(null);

//   useEffect(() => {
//     const fetchContactData = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/contactinfo/get-contact`
//         );
//         if (response.data?.success && response.data?.data) {
//           setContactData(response.data.data);
//           // console.log("data:", response.data.data);
//         }
//       } catch (error) {
//         console.error("Error fetching contact data:", error);
//       }
//     };

//     fetchContactData();
//   }, []);

//   const MessageButton = ({ contactData, formatWhatsAppLink }) => {
//     const openMessageModal = () => {
//       const phoneNumber = contactData?.whatsappNo || "4042002954";
//       const whatsappUrl = formatWhatsAppLink(phoneNumber);

//       window.open(whatsappUrl, "_blank");
//     };

//     return (
//       <>
//         <button
//           onClick={openMessageModal}
//           className="double-blink-button fixed right-6 bottom-6 w-14 h-14 bg-[#25D366] rounded-full shadow-2xl
//                      flex items-center justify-center
//                      hover:bg-[#20ba5a] hover:scale-110 transition-all duration-300 ease-in-out focus:outline-none
//                      border-2 border-white z-9999"
//         >
//           <FaWhatsapp size={28} className="text-white" />
//         </button>

//         <style>
//           {`
//             @keyframes doubleBlink {
//               0%, 100% { opacity: 1; transform: scale(1); }
//               25% { opacity: 0.7; transform: scale(1.05); }
//               50% { opacity: 1; transform: scale(1); }
//               75% { opacity: 0.7; transform: scale(1.05); }
//             }
//             .double-blink-button {
//               animation: doubleBlink 2s infinite;
//             }
//             .double-blink-button:hover {
//               animation: none;
//               transform: scale(1.1);
//             }
//           `}
//         </style>
//       </>
//     );
//   };

//   const ChatBotButton = ({ setIsChatBotOpen }) => {
//     return (
//       <>
//         <button
//           onClick={() => setIsChatBotOpen(true)}
//           className="blink-scale-button fixed right-24 bottom-6 w-14 h-14 bg-primaryBtnHoverColor rounded-full shadow-2xl
//                        flex items-center justify-center
//                        hover:bg-[#252b98] hover:scale-110 transition-all duration-300 ease-in-out focus:outline-none
//                        border-2 border-white z-9999"
//         >
//           <FaRobot size={28} className="text-white" />
//         </button>

//         <style>
//           {`
//     @keyframes blinkScale {
//       0%, 100% {
//         transform: scale(1);
//         opacity: 1;
//         box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);
//       }
//       50% {
//         transform: scale(1.1);
//         opacity: 0.8;
//         box-shadow: 0 0 0 10px rgba(59, 130, 246, 0.4);
//       }
//     }
//     .blink-scale-button {
//       animation: blinkScale 2s infinite;
//     }
//     .blink-scale-button:hover {
//       animation: none;
//       transform: scale(1.1);
//     }
//   `}
//         </style>
//       </>
//     );
//   };

//   return (
//     <React.Fragment>
//       <UserNavbar />
//       {props.children}
//       <UserFooter />

//       <MessageButton
//         contactData={contactData}
//         formatWhatsAppLink={formatWhatsAppLink}
//       />
//       <ChatBotButton setIsChatBotOpen={setIsChatBotOpen} />

//       {isChatBotOpen && <ChatBot onClose={() => setIsChatBotOpen(false)} />}
//     </React.Fragment>
//   );
// };

// export default UserLayout;

import React, { useEffect, useState } from "react";
import UserNavbar from "../../components/common/UserNavbar";
import UserFooter from "../../components/common/UserFooter";
import { FaWhatsapp, FaRobot } from "react-icons/fa6";
import ChatBot from "../../components/common/ChatBot";
import axios from "axios";

const formatWhatsAppLink = (inputNumber, defaultCountryCode = "+1") => {
  if (!inputNumber) return null;

  // Step 1️⃣: Remove everything except digits and '+'
  let cleaned = inputNumber.replace(/[^\d+]/g, "");

  // Step 2️⃣: Handle cases like '001' or '1' prefixes
  if (cleaned.startsWith("00")) {
    cleaned = "+" + cleaned.slice(2);
  }

  // Step 3️⃣: Ensure it starts with '+'
  if (!cleaned.startsWith("+")) {
    // If it starts with country code digit but no '+', add '+'
    if (cleaned.startsWith("1")) {
      cleaned = "+" + cleaned;
    } else {
      cleaned = defaultCountryCode + cleaned;
    }
  }

  // Step 4️⃣: Remove '+' for WhatsApp link format
  const waNumber = cleaned.replace("+", "");

  // Step 5️⃣: Return final WhatsApp link
  return `https://wa.me/${waNumber}`;
};

const UserLayout = (props) => {
  const [isChatBotOpen, setIsChatBotOpen] = useState(false);
  const [contactData, setContactData] = useState(null);

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/contactinfo/get-contact`
        );
        if (response.data?.success && response.data?.data) {
          setContactData(response.data.data);
          // console.log("data:", response.data.data);
        }
      } catch (error) {
        console.error("Error fetching contact data:", error);
      }
    };

    fetchContactData();
  }, []);

  const MessageButton = ({ contactData, formatWhatsAppLink }) => {
    const openMessageModal = () => {
      const phoneNumber = contactData?.whatsappNo || "4042002954";
      const whatsappUrl = formatWhatsAppLink(phoneNumber);

      window.open(whatsappUrl, "_blank");
    };

    return (
      <>
        <button
          onClick={openMessageModal}
          className="double-blink-button fixed right-6 bottom-6 w-14 h-14 bg-[#25D366] rounded-full shadow-2xl
                     flex items-center justify-center
                     hover:bg-[#20ba5a] hover:scale-110 transition-all duration-300 ease-in-out focus:outline-none
                     border-2 border-white"
          style={{ zIndex: 9999 }}
        >
          <FaWhatsapp size={28} className="text-white" />
        </button>

        <style>
          {`
            @keyframes doubleBlink {
              0%, 100% { opacity: 1; transform: scale(1); }
              25% { opacity: 0.7; transform: scale(1.05); }
              50% { opacity: 1; transform: scale(1); }
              75% { opacity: 0.7; transform: scale(1.05); }
            }
            .double-blink-button {
              animation: doubleBlink 2s infinite;
            }
            .double-blink-button:hover {
              animation: none;
              transform: scale(1.1);
            }
          `}
        </style>
      </>
    );
  };

  const ChatBotButton = ({ setIsChatBotOpen }) => {
    return (
      <>
        <button
          onClick={() => setIsChatBotOpen(true)}
          className="blink-scale-button fixed right-24 bottom-6 w-14 h-14 bg-primaryBtnHoverColor rounded-full shadow-2xl
                       flex items-center justify-center
                       hover:bg-[#252b98] hover:scale-110 transition-all duration-300 ease-in-out focus:outline-none
                       border-2 border-white"
          style={{ zIndex: 9999 }}
        >
          <FaRobot size={28} className="text-white" />
        </button>

        <style>
          {`
    @keyframes blinkScale {
      0%, 100% { 
        transform: scale(1);
        opacity: 1;
        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);
      }
      50% { 
        transform: scale(1.1);
        opacity: 0.8;
        box-shadow: 0 0 0 10px rgba(59, 130, 246, 0.4);
      }
    }
    .blink-scale-button {
      animation: blinkScale 2s infinite;
    }
    .blink-scale-button:hover {
      animation: none;
      transform: scale(1.1);
    }
  `}
        </style>
      </>
    );
  };

  return (
    <React.Fragment>
      <UserNavbar />
      {props.children}
      <UserFooter />

      <MessageButton
        contactData={contactData}
        formatWhatsAppLink={formatWhatsAppLink}
      />
      <ChatBotButton setIsChatBotOpen={setIsChatBotOpen} />

      {isChatBotOpen && <ChatBot onClose={() => setIsChatBotOpen(false)} />}
    </React.Fragment>
  );
};

export default UserLayout;
